import * as z from "zod";

export enum ResetExchangeOrderKeptReason {
  /** Some of it already shipped. */
  FULFILLED = "FULFILLED",
  /** Instant exchanges stay with the customer. */
  INSTANT = "INSTANT",
  /** The platform has no cancel API Redo can call. */
  UNSUPPORTED = "UNSUPPORTED",
  /** Redo couldn't read its live status. */
  STATUS_UNAVAILABLE = "STATUS_UNAVAILABLE",
  /** The platform refused the cancel. */
  REFUSED = "REFUSED",
}

export const ResetExchangeOrderSchema = z.object({
  name: z.string(),
  /** Display name of the platform the order lives in, such as "Shopify". */
  platform: z.string(),
  cancellable: z.boolean(),
  keptReason: z.enum(ResetExchangeOrderKeptReason).optional(),
  /** Exchange items a native Shopify exchange added to the original order. */
  native: z.boolean(),
  adminUrl: z.string().optional(),
});
export type ResetExchangeOrder = z.infer<typeof ResetExchangeOrderSchema>;
